import React from 'react'
import { observer, inject } from 'mobx-react'
import { observable, transaction } from 'mobx'
import * as linkConst from '../../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import Datagrid from 'bstrap-react-mobx-admin/datagrid/datagrid'
import TextField from 'react-mobx-admin/components/common/field/text'

const PPRollsTab = ({ store }) => {
  function renderTD (i) {
    if (i === 'ppr_package_title') {
      return (attr, row) => {
        const item = store.options.has(linkConst.LINK_PPROLLS_SETUP) &&
          store.options.get(linkConst.LINK_PPROLLS_SETUP).find((item) => item.name === row[i])
        return store.hasRight(linkConst.LINK_PPROLLS_SETUP) && item && item.id
          ? <TextField attr={attr} val={row[attr]}
            Component={({ text }) => (<a href='javascript:void(0)'
              onClick={() => store.beforeEditViewExit() && store.router.goTo(store.views.entity_detail, { entityname: linkConst.LINK_PPROLLS_SETUP, id: item.id }, store, {})}>{text}</a>)} />
          : <TextField attr={attr} val={row[attr]} />
      }
    } else if (i === 'from') {
      return (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.to} />)
    } else if (i === 'to') {
      return (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.from} />)
    } else {
      return (attr, row) => (<TextField attr={attr} val={row[attr]} />)
    }
  }

  function sortReport (attr, dir) {
    const sortFields = store.cv.sortstate._sortField ? store.cv.sortstate._sortField.split(',') : []
    const sortDirs = store.cv.sortstate._sortDir ? store.cv.sortstate._sortDir.split(',') : []
    const sortStateIdx = sortFields.indexOf(attr)

    if (sortStateIdx >= 0 && dir) {
      sortDirs[sortStateIdx] = dir
    } else if (sortStateIdx >= 0 && dir === null) {
      sortFields.splice(sortStateIdx, 1)
      sortDirs.splice(sortStateIdx, 1)
    } else {
      sortFields.push(attr)
      sortDirs.push(dir)
    }

    const _cmp = (a, b) => {
      for (const fieldId in sortFields) {
        const field = sortFields[fieldId]
        const fieldSortDir = sortDirs[fieldId]
        const sa = '' + a[field]
        const sb = '' + b[field]
        const localCopared = (fieldSortDir === 'ASC') ? sa.localeCompare(sb) : sb.localeCompare(sa)
        if (localCopared === 0) { continue }
        return localCopared
      }
    }

    transaction(() => {
      store.cv.items.replace(store.cv.items.sort(_cmp))
      store.cv.sortstate._sortField = sortFields.join(',')
      store.cv.sortstate._sortDir = sortDirs.join(',')
    })
  }

  function renderReport (items) {
    const attrs = observable(Object.keys(items[0]))
    const fields = Object.keys(items[0]).map((renderTD))
    return (<Datagrid
      attrs={attrs}
      fields={fields}
      onSort={sortReport.bind(store)}
      rowId={(row) => row.id}
      sortstate={store.cv.sortstate}
      state={store.cv}
      titles={attrs}
    />)
  }

  return (
    <div className='card'>
      {store.cv.itemsState === 'loading'
        ? <div><br /><span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />&nbsp; {store.__('Loading...')}</div>
        : (store.cv.items && store.cv.items.length > 0
          ? renderReport(store.cv.items)
          : <div><br />{store.__('EMPTY')}</div>)
      }
    </div>
  )
}

export default inject('store')(observer(PPRollsTab))
